import axios from 'axios';
const NYLAS_PATH = '/integrations/nylas';
const GOOGLE_PATH = '/integrations/google';
const TWILIO_PATH = '/click_to_call/verifications/';

class IntegrationsApi {
  beginNylasIntegration(databaseId, userId, scope, loginHint = '') {
    return axios.post(NYLAS_PATH, {
      nylas_subscription: {
        database_id: databaseId,
        sync_scope: scope,
        login_hint: loginHint,
        user_id: userId
      }
    });
  }

  beginGoogleIntegration(databaseId, userId) {
    return axios.post(GOOGLE_PATH, {
      integrations_google_integration: {
        calendar_database_id: databaseId,
        user_id: userId
      }
    });
  }

  updateNylasIntegration(databaseId, scope, userId) {
    return axios.patch(`${NYLAS_PATH}/${userId}`, {
      nylas_subscription: {
        database_id: databaseId,
        sync_scope: scope
      }
    });
  }

  cancelNylasIntegration(scope, userId) {
    return axios.delete(`${NYLAS_PATH}/${userId}`, {
      data: {
        sync_scope: scope
      }
    });
  }

  cancelGoogleIntegration(userId) {
    return axios.delete(`${GOOGLE_PATH}/${userId}`);
  }

  cancelTwilioIntegration(id, userId) {
    return axios.delete(`${TWILIO_PATH}/${id}?user_id=${userId}`);
  }

  updateGoogleIntegration(databaseId, userId) {
    return axios.patch(`${GOOGLE_PATH}/${userId}`, {
      integrations_google_integration: {
        calendar_database_id: databaseId
      }
    });
  }

  handleCalendarImport(calendar, path, userId) {
    return axios.post(path, {
      import: {
        id: calendar.id,
        name: calendar.name,
        user_id: userId
      }
    });
  }
}

export default IntegrationsApi;
